import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Layout from '../components/layout'
import Slider from "react-slick";

class ProductTemplate extends React.Component {
  render() {
    const prod = get(this.props, 'data.allBigCommerceNode.edges[0].node')
    const proimage = get(this.props, 'data.allBigCommerceNode.edges[0].node.images[0]')
    const siteTitle = get(this.props, 'data.sitePage.context.slug')
    var settings = { dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1 };
    return (
      <Layout location={this.props.location} >
      <link rel="stylesheet" type="text/css" charSet="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
        <div style={{ background: '#fff' }}>
          <Helmet title={`${prod.name}`} />


          <div className="wrapper">
          <div id="slickWrap">
          <Slider {...settings}>

          {prod.images.map(({url_thumbnail}, index) =>(
            <div className="slide">
              <img className="pImage" key={index} src={url_thumbnail}/>
                </div>
              ))}

          </Slider>
          </div>
            <h1 id="productTitle" className="section-headline">{prod.name}</h1>
            <p
              style={{
                display: 'block',
              }}
            >
              ${prod.calculated_price}
            </p>
            <div
              dangerouslySetInnerHTML={{
                __html: prod.description,
              }}
            />
          </div>

        </div>

      </Layout>

    )
  }
}

export default ProductTemplate

export const pageQuery = graphql`
query ProductById($url: String!) {
  sitePage {
    context{
      slug
    }
  }

 allBigCommerceNode(filter: {custom_url: {url: {eq: $url}}}) {
    edges {
      node {
      base_variant_id
      name
      calculated_price
      description
      images {
        url_standard
        url_thumbnail
      }
      upc
      weight
      id
      custom_url{
        url
      }
      }
    }
  }
  fileName: file(relativePath: { eq: "data.allBigCommerceNode.edges[0].node" }) {
      childImageSharp {
        fluid(maxWidth: 400, maxHeight: 250) {
          ...GatsbyImageSharpFluid
        }
      }
    }
}

`
